var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingIcon } from '../icons';
export var Button = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? '' : _e, children = _a.children, rightIcon = _a.rightIcon, buttonRef = _a.buttonRef, _f = _a.isLoading, isLoading = _f === void 0 ? false : _f, props = __rest(_a, ["variant", "size", "fullWidth", "className", "children", "rightIcon", "buttonRef", "isLoading"]);
    var baseStyles = 'inline-flex items-center justify-center font-medium focus:outline-none transition-colors rounded-full';
    var variantStyles = {
        primary: 'bg-vjwPrimary text-white hover:bg-vjwPrimary hover:ring-1 focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary disabled:opacity-50 disabled:cursor-not-allowed',
        secondary: 'bg-vjwSecondary text-vjwPrimary hover:bg-vjwSecondary hover:ring-1 focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary',
        text: 'text-black',
        outline: 'text-vjwPrimary hover:ring-1 hover:bg-vjwSecondary focus:bg-vjwSecondary focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary',
        dangerSecondary: 'bg-vjwDanger/20 text-vjwDanger hover:bg-vjwDanger/30',
        secondaryOutline: 'bg-vjwSecondary text-vjwPrimary hover:bg-vjwSecondary hover:ring-1 focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary border border-vjwPrimary',
    };
    var sizeStyles = {
        sm: 'text-sm px-2 py-1',
        md: 'text-base px-4 py-2',
        lg: 'text-lg px-6 py-3',
    };
    var mergeClasses = function (defaultClasses, customClasses) {
        var defaultClassList = defaultClasses.split(' ');
        var customClassList = customClasses.split(' ');
        var filteredDefaultClasses = defaultClassList.filter(function (defaultClass) {
            return !customClassList.some(function (customClass) { return customClass.startsWith(defaultClass.split('-')[0]); });
        });
        return __spreadArray(__spreadArray([], filteredDefaultClasses, true), customClassList, true).join(' ');
    };
    var combinedClasses = mergeClasses("".concat(baseStyles, " ").concat(variantStyles[variant], " ").concat(sizeStyles[size], " ").concat(fullWidth ? 'w-full' : ''), className);
    return (_jsx("button", __assign({ className: combinedClasses, ref: buttonRef, type: 'button' }, props, { disabled: !!(props === null || props === void 0 ? void 0 : props.disabled) || isLoading, children: isLoading ? (_jsx(LoadingIcon, {})) : (_jsxs(_Fragment, { children: [rightIcon && _jsx("span", { className: 'mr-1', children: rightIcon }), children] })) })));
};
